// Estado real del envio a SUNAT de un comprobante (boleta/factura). "pendiente" solo
// deberia verse un instante ya que el envio es sincronico al emitir (ver SunatBillingService
// en el backend), pero se contempla por si acaso.
export const INVOICE_STATUS_META = {
  pendiente: { label: 'Enviando a SUNAT…', color: 'default', severity: 'info' },
  aceptada: { label: 'Aceptada por SUNAT', color: 'success', severity: 'success' },
  observada: { label: 'Aceptada con observaciones', color: 'warning', severity: 'warning' },
  rechazada: { label: 'Rechazada por SUNAT', color: 'error', severity: 'error' },
  error: { label: 'Error al enviar a SUNAT', color: 'error', severity: 'error' },
  anulada: { label: 'Anulada', color: 'default', severity: 'warning' },
};

export const isAcceptedInvoiceStatus = (status) => ['aceptada', 'observada'].includes(status);
